module.exports = require('./dist/commonjs/index.js').default;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/i18next/index.js
// module id = 2684
// module chunks = 168707334958949